




import { Vue, Component, Prop } from "vue-property-decorator";
import dompurify from "dompurify";

@Component
export default class Sanitized extends Vue {
  @Prop({ default: "span" })
  public tag!: string;

  @Prop({ required: true })
  public text!: string;

  public get sanitized() {
    // See https://github.com/cure53/DOMPurify for options
    // We add attr 'target' so blank links will work from render templates
    return dompurify.sanitize(this.text, { ADD_ATTR: ["target"] });
  }
}
